/**
 * HTTP 客户端
 * 封装带签名认证的 HTTP 请求
 */
export class HttpClient {
  constructor(serverDomain, auth, debug = false) {
    this.serverDomain = serverDomain;
    this.auth = auth;
    this.debug = debug;
  }

  async get(path) {
    return this._request('GET', path, null);
  }

  async post(path, body) {
    return this._request('POST', path, body);
  }

  async _request(method, path, body) {
    // 过滤掉 undefined 字段
    const filteredBody = body ? Object.fromEntries(
      Object.entries(body).filter(([_, v]) => v !== undefined)
    ) : null;

    // 签名计算只使用 URI path（不包含 query string）
    const uriPath = path.split('?')[0];

    const headers = await this.auth.generateHeaders(method, uriPath, filteredBody);
    const url = this.serverDomain + path;

    if (this.debug) {
      console.log(`[IceShuttle HTTP] ${method} ${path}`, filteredBody || '');
      console.log(`[IceShuttle HTTP] 签名路径:`, uriPath);
      console.log(`[IceShuttle HTTP] 请求体字符串:`, filteredBody ? JSON.stringify(filteredBody) : '');
    }

    const response = await fetch(url, {
      method,
      headers,
      body: filteredBody ? JSON.stringify(filteredBody) : undefined
    });

    const result = await response.json();

    if (this.debug) {
      console.log(`[IceShuttle HTTP] 响应:`, result);
    }

    if (result.code !== 200) {
      throw new Error(result.message || `请求失败: ${path}`);
    }

    return result.data;
  }
}
